module.exports = __webpack_public_path__ + "abafde2a8c1a1ef483210fda8d92ade1.svg";